import { useEffect, useState, memo } from "react";
import Menu from "@mui/material/Menu";
import {
  LogoutOutlined as LogoutIcon,
  ChevronRightRounded as ChevronRightIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import config from "../config/config";
import { useSelector, useDispatch } from "react-redux";
import { selectBreadcrumb } from "../features/breadcrumb/breadcrumbSlice";
import Api from "../api/endPoints";
import { closeTabOrRedirectToLogin } from "../api/service";
import { removeUser } from "../features/user/userSlice";
import { icons } from "../utils/iconUtils";

const Header = memo(() => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const state = useSelector(selectBreadcrumb);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await Api.logout();
    } catch (error) {
      console.error("Error logging out:", error);
    } finally {
      dispatch(removeUser());
      localStorage.clear();
      // Notifies other open tabs of this app so their Layout guard kicks in
      window.dispatchEvent(new Event("vecmoconLocalStorageChanged"));
      // This tab was opened by the Vectr platform — close it; falls back to
      // the platform login if the browser blocks the close (deep link).
      closeTabOrRedirectToLogin();
    }
  };

  const handleClick = (link, bool, isBack = false, num = 1) => {
    if (bool) {
      if (isBack) {
        navigate(-num);
      } else {
        navigate(link);
      }
    }
  };

  useEffect(() => {
    const refreshToken = async () => {
      const userToken = localStorage.getItem("token");
      if (!userToken) return;
      try {
        const response = await Api.refreshToken({ userToken });
        if (response.status === 200) {
          const { token } = response.data;
          localStorage.setItem("token", token);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const time = config.refreshTokenTime;
    if (!time || Number.isNaN(time)) return;
    const interval = setInterval(refreshToken, time * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const meApiImgUrl = `${config.apiUrl}/auth-engine/media/profileImage?imageUrl=${user?.imageUrl}`;

  return (
    <>
      <div className="bg-[#F9FAFA] w-full h-12 flex justify-between py-2 px-6 sticky top-0 z-[999] border-b border-[#DFE4ED]">
        <div className="flex items-center content-between justify-between w-full gap-2">
          <div className="flex items-center gap-0.5">
            {state.map((e, i) => (
              <div key={i} className="flex items-center gap-0.5">
                {i !== 0 && (
                  <ChevronRightIcon sx={{ fontSize: 12, color: "#616A79" }} />
                )}
                <span
                  className="text-xs leading-4"
                  style={{
                    color: e.current ? "#272D37" : "#616A79",
                    fontWeight: "400",
                    cursor: !e.current ? "pointer" : "default",
                  }}
                  onClick={() => handleClick(e.link, !e.current, e?.isBack)}
                >
                  {e.title}
                </span>
              </div>
            ))}
          </div>
          <div className="flex flex-row gap-4 items-center">

            <div
              onClick={handleMenu}
              className="flex flex-row items-center justify-center gap-0.5 p-1 hover:bg-slate-200 transition-all ease-in rounded-full cursor-pointer"
            >
              <div
                className={`w-6 h-6 flex-shrink-0 bg-[#FFEDED] rounded-full flex items-center justify-center object-cover object-center overflow-hidden`}
              >
                {user?.imageUrl ? (
                  <img src={meApiImgUrl} alt="User-Image" loading="lazy" />
                ) : (
                  <span className="text-[#C32925] text-sm font-semibold leading-5">
                    {user?.name?.charAt(0)}
                  </span>
                )}
              </div>
              <div className="w-5 h-5 flex items-center justify-center text-[#616A79]">
                {icons?.downArrowIcon}
              </div>
            </div>
            <Menu
              id="menu-appbar"
              aria-modal
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              keepMounted
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{ style: { width: "250px", marginTop: "36px" } }}
            >
              <div className="p-4 w-full flex flex-row gap-4 items-center justify-start">
                <div
                  className={`w-14 h-14 p-1 flex-shrink-0 bg-[#fde9e7] rounded-full flex items-center justify-center object-cover object-center overflow-hidden`}
                >
                  {user?.imageUrl ? (
                    <img src={meApiImgUrl} alt="User-Image" loading="lazy" />
                  ) : (
                    <span className="text-[#d51d10] text-3xl font-semibold">
                      {user?.name?.charAt(0)}
                    </span>
                  )}
                </div>
                <div>
                  <div className="text-[#252a34] text-md font-medium  leading-tight">
                    {user?.name}
                  </div>
                  <div className="text-[#555e6f] text-sm font-normal  leading-none mt-1">
                    {user?.role?.name}
                  </div>
                </div>
              </div>
              <hr className="border-[#e5e9f0]" />
              <li
                onClick={handleLogout}
                className="text-[#d51d10] text-sm font-normal  leading-tight flex flex-row items-center justify-start px-4 py-2 cursor-pointer ease-in transition-all hover:text-[#d51d10] hover:bg-[#f3f5f8] gap-2"
              >
                <LogoutIcon fontSize="small" />
                <p> Log out </p>
              </li>
            </Menu>
          </div>
        </div>
      </div>
    </>
  );
});

export default Header;
